<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-table-column">
    <el-dropdown class="wy-table-column-dropdown" ref="generalFilter" :hide-on-click="false" placement="bottom"
      trigger="click" @visible-change="handleVisibleChange">
      <el-tooltip class="item" effect="dark" content="Show/hide columns" placement="bottom" :disabled="this.$refs.generalFilter ? this.$refs.generalFilter.visible : false">
        <el-button :disabled="disableColumn" :class="(isDropdownOpen? 'el-dropdown-title-open wy-disable-select':'el-dropdown-title wy-disable-select')" :data-testid="dataTestId"> <span :class="dropdownClassName">Columns</span></el-button>
      </el-tooltip>
      <el-dropdown-menu class="wy-table-column-panel">
        <div class="div-title">Columns
          <img class="table-column-close-icon" src="../../assets/icons/icon_customer_close.svg" @click="handleCancel">
        </div>
        
        <div class="div-content">
          <div class="div-select-all">
            <el-checkbox :label="'All'" v-model="isSelectAll" @change="handleSelectAllChange">All</el-checkbox>
          </div>
          <div class="div-single-column" v-if="!hidePercentageAll">
            <el-checkbox :label="'% change for all metrics'" :disabled="isDisabledPercentageAll" v-model="showPercentChangeForAll" @change="handlePercentChange">% change for all metrics</el-checkbox>
          </div>
        
          <div v-for="(item, index) in groupedColumns" :key="index">
            <div v-if="item.columns">
              <div v-if="item.columns && item.columns.length>1">
                <div :name="item.label">

                    <div class="radio-group-title" v-if="item.type=='singleSelect'">
                      <el-checkbox v-model="item.checked" @change="handleGroupCheckRadio(item)">{{item.label}}</el-checkbox>
                    </div>
                    <div v-else>
                      <el-checkbox v-model="item.checked" @change="handleGroupCheck(item)">{{item.label}}</el-checkbox>
                    </div> 
              
                  <div v-if="item.type=='singleSelect'" style="margin-left: 20px; display: inline-grid;">
                    <el-radio v-for="(child, index) in item.columns" :label="child.name" v-model="item.selectedKey" :key="index" :disabled="!item.checked"  @change="itemRadioChanged(item, child)">{{child.label}}</el-radio>
                  </div>
                  <div v-else style="margin-left: 20px; display: inline-grid;" class="radio-option">
                    <el-checkbox v-for="(child, index) in item.columns" :label="child.name" :key="index" v-model="child.selected" @change="itemChanged(item, child)">{{child.label}}</el-checkbox>
                  </div>
                </div>
              </div>
              <div v-if="item.columns && item.columns.length==1 && !item.hide">
                <div class="radio-group-title" v-if="(!item.type || item.type=='singleSelect') && item.label.trim()!=''">
                  <el-checkbox v-model="item.checked">{{item.label}}</el-checkbox>
                  </div>
                <div v-else>
                  <el-checkbox v-model="item.checked">{{item.columns[0].label}}</el-checkbox>
                </div> 
              </div>
            </div>
            <div v-else class="div-single-column">
              <el-checkbox :label="item.label" v-model="item.selected">{{item.label}}</el-checkbox>
            </div>  
            <div v-if="!item.hide" class="last-div"></div> 
          </div>
        </div>
        <hr class="response-col-horizontal-line">
        <div class="table-col-bottom-flex">
          <span class="table-column-search-reset-btn" @click="initColumns(false)">Reset all</span>
          <div style="display: flex;">
            <span class="table-column-search-cancel-btn" @click="handleCancel">Cancel</span>
            <span v-if="$refs.generalFilter" class="table-column-search-apply-btn" @click="handleApply">Apply</span>
          </div>
        </div>
      </el-dropdown-menu>
    </el-dropdown> 
    
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'wy-table-column',
  props: {
      'controller': Object,
      'hidePercentageAll': {
        type: Boolean,
        default: false
      },
      'dropdownClassName': {
        type: String,
        default: 'table-col-dropdown-text-hide'
      },
      'dataTestId': {
        type: String,
        default: null
      }

  },
  
  data() {
    return {
      cloneColumns: null,
      cloneGroupedColumns: null,
      groupedColumns: null,
      currentColumns: [],
      // activeNames: [],
      colDropdownOpen: false,
      isDropdownOpen: false,
      groupList: [],
      applyTriggered: false,
      showPercentChangeForAll: true,
      parentComponentName: null,
    };
  },

  computed: {
    ...mapGetters(['dataModel', 'tableModel']),

    allLanguages() {
      return this.$store.getters.supportedLanguages;
    },

    isCollapse() {
      return true;
    },

    isDisabledPercentageAll() {
      let isDisabled = true;
      this.groupedColumns && this.groupedColumns.length && this.groupedColumns.forEach(item=>{
        if(item.checked) {
          isDisabled = false
        }
      })
      if(isDisabled) {
        this.uncheckShowPercentChangeForAll();
      }
      return isDisabled;
    },
    disableColumn() {
      let available = true;
      if(this.tableModel && this.tableModel.results && this.tableModel.results.length == 0) {
        available = false;
      }
      return !available;
    },

    isSelectAll: {
      get() {
        let selectAll = true;
        if(this.groupedColumns) {
          this.groupedColumns.forEach(column => {
            if(!column.checked || !this.showPercentChangeForAll) {
              selectAll = false;
            }
          })
        }
        else {
          selectAll = false;
        }
        return selectAll;
      },
      set() {
      }
    }
  },

  methods: {
    initColumns(useSessionStorage) {
      // Note: If the table columns were to change, we need to force user logout to clear the session storage
      // Future fix could be lodash deep compare or checking the column names and lengths
      this.cloneColumns = JSON.parse(JSON.stringify(this.dataModel.columns));
      this.groupedColumns = JSON.parse(JSON.stringify(this.getGroupedColumns()));
      this.showPercentChangeForAll = true;

      if (useSessionStorage) {
        const sessionStorage = this.$store.getters.getBrowserSessionStorageByUser(this.parentComponentName);
        if (sessionStorage) {
          this.cloneColumns = sessionStorage.cloneColumns && sessionStorage.cloneColumns.length ? sessionStorage.cloneColumns : JSON.parse(JSON.stringify(this.dataModel.columns)),
          this.groupedColumns = sessionStorage.groupedColumns && sessionStorage.groupedColumns.length ? sessionStorage.groupedColumns : JSON.parse(JSON.stringify(this.getGroupedColumns())),
          this.showPercentChangeForAll = sessionStorage.showPercentChangeForAll != null ? sessionStorage.showPercentChangeForAll : true
        }
      }

      this.$store.dispatch('updateBrowserSessionStorageByUser', { key: this.parentComponentName, value: {
        cloneColumns: this.cloneColumns,
        groupedColumns: this.groupedColumns,
        showPercentChangeForAll: this.showPercentChangeForAll
      } });
    },


    updateSessionStorage() {
      this.$store.dispatch('updateBrowserSessionStorageByUser', { key: this.parentComponentName, value: {
        cloneColumns: JSON.parse(JSON.stringify(this.dataModel.columns)),
        groupedColumns: this.groupedColumns,
        showPercentChangeForAll: this.showPercentChangeForAll
      }});
    },

    handleApply() {
      this.applyTriggered = true;
      this.$refs.generalFilter.hide();
    },

    handleCancel() {
      this.groupedColumns = JSON.parse(JSON.stringify(this.cloneGroupedColumns));
      this.showPercentChangeForAll = this.$store.getters.getBrowserSessionStorageByUser('showPercentChangeForAll')!=null ? this.$store.getters.getBrowserSessionStorageByUser('showPercentChangeForAll') : true
      if(this.$refs.generalFilter) this.$refs.generalFilter.hide();
    },

    uncheckShowPercentChangeForAll() {
      this.showPercentChangeForAll = false;
    },

    handleSelectAllChange(checked) {
      if(checked) {
        this.groupedColumns.forEach(item=>{
          item.checked = true;
          if(item.columns && item.columns.length > 1) {
            this.handleGroupCheck(item)
          }
        })
        this.showPercentChangeForAll = true;
      }
      else {
        this.groupedColumns.forEach(item=>{
          item.checked = false;
          if(item.columns && item.columns.length > 1) {
            this.handleGroupCheck(item)
          }
        })
        this.showPercentChangeForAll = false;
      }
    },

    handlePercentChange(val) {
      this.showPercentChangeForAll = val;
      const sessionStorage = this.$store.getters.getBrowserSessionStorageByUser(this.parentComponentName);

      if (sessionStorage) {
        this.$store.dispatch('updateBrowserSessionStorageByUser', { key: this.parentComponentName, value: {
          ...sessionStorage,
          showPercentChangeForAll: val
        }});
      } 
    },

    handleGroupCheck(group) {
      // this.dataModel.columns.filter(el => el.group==group.label && !el.parent).forEach(child => child.selected = group.checked);
      group.columns.forEach((column)=>{
        column.selected = group.checked
      })
    },

    handleGroupCheckRadio(group) {
      // this.dataModel.columns.filter(el => el.group==group.label && !el.parent).forEach(child => child.selected = group.checked);
      if(group.checked) {
        group.columns.forEach((column)=>{
          if(group.selectedKey == column.name) {
            column.selected = group.checked;
          }
        })
      }
      else {
        group.columns.forEach((column)=>{
          column.selected = group.checked
        })
      }
    },

    itemChanged(item) {
      let allChecked = true;
      let allUnChecked = true;
      item.columns.forEach(el=>{
        if(!el.selected){
          allChecked = false
        }
        if(el.selected) {
          allUnChecked = false
        }
      })
      if(allChecked){
        item.isIndeterminate = false
        item.checked = true;
      }
      if(!allUnChecked && !allChecked){
        item.checked = true;
        item.isIndeterminate = true
      }
      if(allUnChecked){
        item.checked = false;
        item.isIndeterminate = false
      }
    },

    itemRadioChanged(item) {
      item.columns.forEach(el=>{
        el.selected = false;
        if(el.name == item.selectedKey) {
          item.checked = true;
          el.selected = true;
        }
      })
    },

    handleVisibleChange(isShow, isFromMounted) {
      if(!isShow) {
        this.colDropdownOpen = false;
        this.$root.$emit(`fire-col-events`, this.colDropdownOpen);

        let isChanaged = false;
        this.dataModel.columns.forEach(modelColumn=>{
          this.groupedColumns.forEach(groupedColumn => {
            if(groupedColumn.columns && groupedColumn.columns.length==1) {
              if(groupedColumn.columns[0].group == modelColumn.group && groupedColumn.columns[0].name == modelColumn.name && modelColumn.selected != groupedColumn.checked) {
                modelColumn.selected = groupedColumn.checked;
                isChanaged = true;
              }
            }
            else if(groupedColumn.columns) {
              groupedColumn.columns.forEach(column => {
                if(column.group == modelColumn.group && column.name == modelColumn.name && modelColumn.selected != column.selected) {
                  modelColumn.selected = column.selected;
                  isChanaged = true;
                }
              })
            }
            else {
              if(groupedColumn.name == modelColumn.name && modelColumn.selected != groupedColumn.selected) {
                modelColumn.selected = groupedColumn.selected;
                isChanaged = true;
              }
            }
          })
        })
        
        // Selecting/De-selecting all '% total' entries
        this.dataModel.columns.filter((el)=>el.type=='percentChange').forEach(modelColumn=>{
          let isParentSelected =           
              (!modelColumn.parent && this.groupedColumns.find((el)=>el.label==modelColumn.group).checked) ||   // if no parent, then is its group selected?              
              (modelColumn.parent && this.dataModel.columns.find((el)=>el.name==modelColumn.parent) && this.dataModel.columns.find((el)=>el.name==modelColumn.parent).selected);  // if has parent, then is its parent selected?
          let result = isParentSelected && this.showPercentChangeForAll;
          if (modelColumn.selected != result)
            isChanaged = true;
          modelColumn.selected = result;
        })
        // this.$store.dispatch('updateBrowserSessionStorageByUser', {key: "showPercentChangeForAll", value: this.showPercentChangeForAll});
        if(isChanaged && this.controller.$refs.table && this.controller.$refs.table.finishParentRender) this.controller.refreshTable();
        // if(this.applyTriggered && this.controller.handleTableColumnApplyAmplitude) {
        if(!isFromMounted && (isChanaged || this.applyTriggered) && this.controller.handleTableColumnApplyAmplitude) {
          let updateColumnsInfo = this.getUpdateColumnsInfo();
          updateColumnsInfo.changes_made = isChanaged;
          updateColumnsInfo.all_selected = this.isSelectAll;
          this.controller.handleTableColumnApplyAmplitude(updateColumnsInfo);
          this.applyTriggered = false;
        }
        if(this.$refs.generalFilter) this.$refs.generalFilter.hide();

        // update browser session storage
        this.updateSessionStorage();
      }
      else {
        if(this.controller.handleTableColumnOpenAmplitude) {
          this.controller.handleTableColumnOpenAmplitude();
        }
        this.currentColumns = JSON.parse(JSON.stringify(this.dataModel.columns));
        this.colDropdownOpen = true;
        this.$root.$emit(`fire-col-events`, this.colDropdownOpen);
        this.cloneGroupedColumns = JSON.parse(JSON.stringify(this.groupedColumns));

        this.dataModel.columns.forEach(modelColumn=>{
          this.groupedColumns.forEach(groupedColumn => {
            if(groupedColumn.columns && groupedColumn.columns.length == 1 && groupedColumn.columns[0].name == modelColumn.name) {
              groupedColumn.checked = modelColumn.selected;
              if(modelColumn.hide) {
                groupedColumn.hide = modelColumn.hide;
              }
              else {
                groupedColumn.hide = false;
              }
              groupedColumn.columns = [];
              groupedColumn.columns.push(modelColumn);
            }
            else if(groupedColumn.columns && groupedColumn.columns.length > 1) {
              groupedColumn.columns.forEach(column => {
                if(column.group == modelColumn.group && column.name == modelColumn.name && modelColumn.selected != column.selected) {
                  column.selected = modelColumn.selected;
                }
              })
            }
            else {
              if(groupedColumn.name == modelColumn.name && modelColumn.selected != groupedColumn.selected) {
                groupedColumn.selected - modelColumn.selected;
              }
            }
          })
        })

        // update browser session storage
        this.updateSessionStorage();
      }
    },

    getUpdateColumnsInfo() {
      let updateColumnsInfo = {
        columns_added: [],
        columns_removed: [],
        columns_selected:[]
      }
      this.dataModel.columns.forEach(columnNew => {
        this.currentColumns.forEach(columnOld => {
          if(columnOld.name == columnNew.name) {
            if(!columnOld.selected && columnNew.selected) {
              updateColumnsInfo.columns_added.push(columnNew.name);
            }
            if(columnOld.selected && !columnNew.selected) {
              updateColumnsInfo.columns_removed.push(columnNew.name);
            }
          }
        })
        if(columnNew.selected) {
          updateColumnsInfo.columns_selected.push(columnNew.name)
        }
      })
      return updateColumnsInfo
    },
    

    getGroupedColumns() {
      if(this.groupList && this.groupList.length == 0) {
        let groupMap = {};
        this.cloneColumns.filter(/*el => !el.parent*/(el)=> el.type != "percentChange").forEach(column => {
          if(column.groupHidden) {
            groupMap[column.group] = column;
          }
          else {
            if(!groupMap[column.group]) {
              groupMap[column.group] = {
                label: column.group,
                mandatory: column.mandatory,
                columns: [],
                isIndeterminate: false,
                checkecdVolumns: [],
                checked: false,
                hide: false,
                selectedKey: column.name,
                type: column.type?column.type:null
              };
            }
            groupMap[column.group].columns.push(column);
          }  
        });

        Object.keys(groupMap).forEach(key => {
          let group = groupMap[key];
          this.groupList.push(group);
        });

        this.groupList.forEach(element => {
          if(element.columns) {
            this.itemChanged(element)
          }
        })
      }
      return this.groupList.filter(el => !el.mandatory);
    },
  },
  mounted(){
    if(document.querySelector('.wy-container-main')){
      document.querySelector('.wy-container-main').addEventListener('scroll', () => {
        if(this.$refs.generalFilter)this.$refs.generalFilter.hide()
      })
    }

    this.$root.$on(`fire-col-events`, (isDropdownOpen) => {
      this.isDropdownOpen = isDropdownOpen;
    })
  },

  created() {   
    this.parentComponentName = this.$parent.$options.name;
    this.initColumns(true); 
    this.handleVisibleChange(false, true);
  },
  beforeDestroy() {
    if(document.querySelector('.wy-container-main')){
      document.querySelector('.wy-container-main').removeEventListener('scroll', () => {
        if(this.$refs.generalFilter)this.$refs.generalFilter.hide()
      })
    }
  },
}
</script>

<style lang="scss">
.table-column-setting-popper {
  background: transparent;
  box-shadow: unset !important;
  border: unset;
  max-width: 292px !important;
  margin-left: 465px;
}
.wy-table-column {
  .wy-table-column-dropdown {
    .table-col-dropdown-text-hide{
      display: inline-block;
      color: var(--site-font-tertiary-color);
    }
    .table-col-dropdown-text-show{
      display: inline-block;
    }
    .el-dropdown-title,.el-dropdown-title-open {
      cursor: pointer;
      background: #FFF url('../../assets/icons/choose_columns.svg') no-repeat 11px center;
      background-size: 16%;
      height: 36px;
      margin-top: 1px;
      width: 100px;
      margin-right: 34px;
      color: var(--site-font-tertiary-color);
      display: flex;
      border-radius: 5px;
      border: 1px solid #CAD2DA;
      bottom: 1px;
      position: relative;
      padding: 12px 12px;
      margin-right: 0px;
      justify-content: flex-end;
      align-items: center;  
    }

    .el-button:focus, .el-button:hover {
      background-color: #F4F6F8 !important;
    }
  }
  .wy-table-column-dropdown {
    background-repeat: no-repeat;
    background-position-x: right;
    background-position-y: 6px;
    background-size: 5px 8px;
    border-radius: 5px;
    opacity: 1;
    padding: 0px 0px 0px 0px;
    text-align: right;
    height: 35px;
    min-width: 100px;
    background-color: transparent;

    .el-icon-caret-right {
      background-image: url('../../assets/icons/icon_dropdown_arrow_down.png');
      background-repeat: no-repeat;
      background-size: 8px 5px;
      background-position-x: 3px;
      background-position-y: 2px;
      width: 11px;
      height: 10px;
      vertical-align: middle;
    }
    
    .el-icon-caret-right:before {
      content: "";
    }
  }
  .wy-table-column:hover {
    background: #EBF4FD 0% 0% no-repeat padding-box;
  }
  .wy-table-column.opened {
    background-position-y: 8px;
    background-size: 8px 5px;
    .el-dropdown-title {
      color: var(--site-font-tertiary-color);
      font-weight: 600;
    }
    .el-icon-caret-right:before {
      content: "";
    }
  }
}
.wy-table-column-panel :last-child {
  border-bottom: 0 !important;
}
.wy-table-column-panel {
  top: 140px !important;
  transition-duration: 0s;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 5px 5px 6px #00000029;
  border: 1px solid #F4F6F8 !important;
  border-radius: 10px;
  opacity: 1;
  width: 312px;
  display: inline-block;
  // height: 550px;
  max-height: 514px;
  min-height: 100px;
  height: calc(100vh - 200px);
  background-color: #fff;
  padding: 17px 0px 6px 0px;
  margin: 5px 0 0 0;
  .el-radio__input.is-checked .el-radio__inner{
    background: #106FBC !important;
    border: 1px solid #106FBC !important;
  }
  .response-col-horizontal-line{
    border-top: 0.1px solid #CAD2DA;
    border-left: 1px solid #CAD2DA;
    width: 100%;
    border-bottom: 1px solid transparent;
    margin-top: 0px;
  }
  .table-col-bottom-flex{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .table-column-search-reset-btn{
    font-size: 14.22px;
    // color: #106FBC;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    margin-left: 20px;
    cursor: pointer;
  }
  .table-column-search-cancel-btn {
    padding: 10px 16px;
    color: var(--site-button-cancel-btn-primary-color);
    border: 1px solid var(--site-button-cancel-btn-primary-border-color);
    border-radius: 5px;
    height: 15px;
    width: 45px;
    font-size: 14px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .table-column-search-apply-btn {
    padding: 10px 16px;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 13px;
    background: var(--site-button-primary-btn-background-primary-color);
    color: var(--site-button-primary-btn-text-primary-color);
    border: 1px solid var(--site-button-primary-btn-hover-border-primary-color);
    border-radius: 5px;
    height: 15px;
    width: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
  }
  .table-column-search-apply-btn:hover {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    background-color: var(--site-button-primary-btn-hover-background-primary-color) !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .table-column-search-apply-btn:active {
    background-color: var(--site-button-primary-btn-pressed-background-primary-color) !important;
  }
  .table-column-search-apply-btn:focus {
    border: 1px var(--site-button-primary-btn-hover-border-primary-color) solid !important;
    border-radius: 5px;
    color: var(--site-button-primary-btn-text-primary-color) !important;
  }
  .div-title {
    font-weight: 400;
    padding-bottom: 15px;
    border-bottom: 1px solid #CAD2DA;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    padding: 2px 0 18px 20px;
    width: 93.5%;
    color: #202223;
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  img.table-column-close-icon {
    float: right;
    width: 14px;
    margin-right: 27px;
    cursor: pointer;
  }
  .div-content {
    // max-height: calc(100vh - 180px);
    overflow-y: auto;
    // height: 446px;
    max-height: 410px;
    height: calc(100vh - 305px);
    width: 95%;
    padding-left: 10px;
    padding-top: 15px;

    &::-webkit-scrollbar {
      background-color: white !important;
      width: 6.5px !important;
    }
    &::-webkit-scrollbar-thumb{
      background: #CAD2DA !important;
      border-radius: 5px;
    }

    .el-collapse-item:last-child {
      margin-bottom: 0 !important;
    }

    .el-checkbox__inner {
      border: 1px solid var(--primary-checkbox-button-border-color) !important;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      border: 1px solid var(--primary-checkbox-button-disabled-border-color) !important;
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner:hover {
      box-shadow: unset !important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner{
      background-color: var(--primary-checkbox-button-check-color);
    }
    span.el-checkbox__inner:hover {
      // box-shadow: unset !important;
      -webkit-box-shadow: var(--primary-checkbox-button-hover-box-shadow)  !important;
      box-shadow: var(--primary-checkbox-button-hover-box-shadow) !important;
    }
  }

  .last-div {
    padding-bottom: 10px;
  }

  label.el-checkbox {
    padding: 3px 0 0px 0;
    margin-bottom: 18px;
    margin-left: 11px;
  }
  .div-single-column {
    padding: 5px 0 0 0;
  }
  .el-checkbox__label {
    font-size: 14.22px;
  }
  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: var(--site-font-tertiary-color);
    font-size: 14.22px;
  }
  .el-collapse {
    border-top: 0px solid #EBEEF5;
    border-bottom: 0px solid #EBEEF5;
  }
  .el-collapse-item__wrap {
    border-bottom: 0px solid #EBEEF5;
  }
  .el-collapse-item__content .el-checkbox {
    display: block !important;
  }
  .el-collapse-item__content {
    padding-bottom: 0px;
  }
  
  .el-dropdown-menu__item:hover {
    background-color: #fff !important;
  }

  .el-dropdown-menu__item{
    cursor: default;
    padding: 0px;

    .el-collapse {
      border-bottom: 0;
      border-top: 0px;
    }

    .el-collapse-item__wrap{
      border-bottom: 0 !important;
    }

    .el-collapse-item:last-child {
      margin-bottom: 20px;
      .el-collapse-item__header, .el-collapse-item__wrap {
        border-bottom: 0 !important;
      }
    }
    span.filter-header {
      padding: 0px 15px;
      font-weight: bold;
      color: #214586;
      font-size: 14px;
      cursor: pointer;
    }
    
    .el-collapse-item__header {
      padding: 0px 15px;
      background-color: #fff;
      height: 36px;
      color: var(--site-font-primary-color);
      border-bottom: 0 !important;
    }
    .el-collapse-item__content {
      padding: 0px 30px;
      background-color: #fff;
      display: inline-block;
      .el-checkbox__inner {
        border-radius: 5px;
        width: 18px;
        height: 18px;
      }
    }
    .el-checkbox__label {
      padding-bottom: 5px;
      line-height: 15px;
      font-size: 12px;
      color: var(--site-font-primary-color);
    }
    .el-checkbox__input.is-indeterminate .el-checkbox__inner{
      background-color: #63CABA;
      border: 1px solid #63CABA;
    }
    .el-checkbox__input.is-focus {
      .el-checkbox__inner{
        border: 1px solid #214586 !important;
        border-color: #214586 !important;
      }
    }
    
  }
  .el-radio__inner:hover {
    border-color: #214586 !important;
  }
  div.filter-clear-all {
    font-size: 14px;
    color: #214586;
    float: right;
    cursor: pointer;
    position: absolute;
    top: 20px;
    right: 20px;
  }
  .el-dropdown-menu__item.is-disabled {
    border-bottom: 1px solid #EBEEF5;
  }
  .el-collapse-item__wrap {
    background-color: #fff;
    padding-bottom: 0px;
  }
  .el-checkbox__input.is-indeterminate .el-checkbox__inner::before {
    top: 6px;
    border: 1px #fff solid;
  }
  .el-checkbox__inner::after {
    box-sizing: content-box;
    content: "";
    border: 2px solid #FFF;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: 4px;
    position: absolute;
    top: 1px;
    -webkit-transform: rotate(45deg) scaleY(0);
    transform: rotate(45deg) scaleY(0);
    width: 3px;
    -webkit-transition: -webkit-transform .15s ease-in .05s;
    transition: -webkit-transform .15s ease-in .05s;
    transition: transform .15s ease-in .05s;
    transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;
    transition: transform .15s ease-in .05s,-webkit-transform .15s ease-in .05s;
    -webkit-transform-origin: center;
    transform-origin: center;
  }


  /* configure panel */
  span.filter-title{
      padding-left: 15px;
      font-size: 12px;
      width: 100%;
  }
  .filter-value {
    display: inline-block;
    padding-left: 10px;
    font-size: 12px;
    input {
      width: 30px;
      text-align: right;
      font-size: 12px;
      height: 20px;
      border: 0px;
      margin: 1px;
    }
    .el-input-number.is-controls-right .el-input__inner{
      padding-left: 0px;
      padding-right: 0px;
    }
  }
  .filter-value-boolean  {
    display: inline-block;
    width: 80px;
    padding-left: 14px;
  }
  .el-input-number--mini {
    -webkit-appearance: none;
    background-color: #fff;
    background-image: none;
    border-radius: 4px;
    border: 1px solid #d8dce5;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 70px;
    line-height: 20px;
    .el-icon-arrow-up,.el-icon-arrow-down{
      line-height: 0;
    }
    .el-input-number__decrease,.el-input-number__increase {
      line-height: 10px !important;
    }
  }
  .el-radio {
    width: 40px;
    margin-right: 0px;
  }
  .el-radio:last-child {
    width: 40px;
    margin-right: 0px;
    padding-bottom: 0px !important;
  }
  .el-radio__label {
    font-size: 12px;
    padding-left: 5px;
  }
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #214586;
    background: #214586;
  } 
  .el-radio__input.is-checked+.el-radio__label {
    color: #214586;
  } 
  .el-dropdown-menu__item:not(.is-disabled):hover {
    // background-color: #ecf5ff;
    color: var(--site-font-drop-down-secondary-color);
  }
  .filter-config {
    padding-bottom: 10px;
    font-weight: bold;
    color: #214586;
    font-size: 14px;
    .filter-section{
      color: var(--site-font-drop-down-secondary-color);
      line-height: 36px;
      font-weight:normal;
    }
    .filter-section-header {
      padding-left: 15px;
      line-height: 36px;
      border-bottom: 1px solid #EBEEF5;
      margin-bottom: 5px;
    }
  }
  .el-collapse-item__content{
    .el-checkbox{
      display: none;
    }
    .el-checkbox-group{
      .el-checkbox{
        display: block;
      }
    }
  }
  .radio-group-title {
    font-size: 14px !important;
  }
  .el-radio {
    padding: 3px 0 12px 0;
    font-weight: 500;
  }
  .el-radio__label {
    font-size: 14px !important;
  }
  .el-collapse-item__header{
    height: 40px !important;
    line-height: unset;
  }
  .popper__arrow {
    display: none;
  }
}
</style>
